import axios from 'axios';
import { useCallback, useState } from 'react';
import { useOnRepetition } from "./useOnRepetition";
/**
 * Gets the gas price from Eth Gas Station
 * @param targetNetwork (TNetwork)
 * @param speed (TGasStationSpeed) 'fast', 'fastest', 'safeLow', 'average'
 * @param pollTime (number) :: if > 0 use polling, else use instead of onBlock event
 * @returns (number) gas price in gwei
 */
export const useGasPrice = (targetNetwork, speed, pollTime = 39999) => {
    const multiplier = 100000000;
    const [gasPrice, setGasPrice] = useState();
    const loadGasPrice = useCallback(() => {
        if (targetNetwork === null || targetNetwork === void 0 ? void 0 : targetNetwork.gasPrice) {
            setGasPrice(targetNetwork.gasPrice);
        }
        else {
            if (navigator.onLine) {
                axios
                    .get('https://ethgasstation.info/json/ethgasAPI.json')
                    .then((response) => {
                    var _a;
                    const result = (_a = response.data) !== null && _a !== void 0 ? _a : {};
                    let newGasPrice = result[speed] * multiplier;
                    if (!newGasPrice)
                        newGasPrice = result['fast'] * multiplier;
                    if (newGasPrice !== gasPrice) {
                        setGasPrice(newGasPrice);
                    }
                })
                    .catch((error) => {
                    console.log('⚠ Could not get gas Price!', error);
                    setGasPrice(undefined);
                });
            }
        }
    }, [gasPrice, speed, targetNetwork.gasPrice]);
    useOnRepetition(loadGasPrice, { pollTime, leadingTrigger: true });
    return gasPrice;
};
